// import Swiper from 'swiper';
const Map = {
    init() {
        // JavaScript to be fired on the home page
        this._jMapWrapper = $('.map-container');

        this._addEvents();
        this.finalize();
    },
    
    _addEvents() {

    },
    finalize() {
        this.initMap();
    },
    initMap() {
            $('#mapplic').mapplic({
            source: '/wp-content/themes/mint/resources/assets/scripts/customjs/mall.json',
            sidebar: true,
            toggle: true,
            alphabetic: true,
            height: 560,
            developer: true,
            searchdescription: true,
            searcheverywhere: true,
            animations: true,
            hovertip: true,
            minimap: false,
            marker: 'hidden',
            fillcolor: false,
            fullscreen: false,
            thumbholder: true,
            maxscale: 3,
        });            
      
    },
};

export default Map;


// WEBPACK FOOTER //
// ./scripts/modules/map.js